var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv overlay=\"$ctrl.loading\"\u003E\u003Cbutton class=\"button button-primary\" ng-click=\"$ctrl.openDialog()\"\u003EMeine Unterlagen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;